/**
 * Shared defaults for Leads queries
 * 
 * These defaults ensure consistency between:
 * - useLeadsQuery hook
 * - useBootstrapLeadsData prefetch hook
 * - LeadsPage component initial state
 * 
 * This guarantees that the prefetch query key exactly matches
 * the initial Leads page query, so cached data is used immediately.
 */

import { LeadsQueryParams } from './queries/useLeadsQuery';

export const DEFAULT_LEADS_PAGE = 1;
export const DEFAULT_LEADS_PAGE_SIZE = 25; // Default page size (lightweight prefetch)
export const LEADS_PAGE_SIZE_OPTIONS = [25, 50, 100] as const;

/**
 * Default query parameters for Leads list queries
 * 
 * These are used for:
 * - Initial Leads page load
 * - Bootstrap prefetch (first page only, lightweight)
 * - Fallback values in useLeadsQuery
 * 
 * IMPORTANT: All optional fields are explicitly set to undefined
 * to ensure query key consistency (undefined vs missing = different keys).
 */
export const DEFAULT_LEADS_QUERY_PARAMS: LeadsQueryParams = {
  page: DEFAULT_LEADS_PAGE,
  limit: DEFAULT_LEADS_PAGE_SIZE,
  search: '',
  status: undefined,
  managerId: undefined,
  rating: undefined,
  source: undefined,
  leadNum: undefined,
  firstName: undefined,
};

